import CrudAPIClient from '../crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { MetaQuery } from '@refinedev/core';
import { axiosInstance } from '../axios';

export default class StyleBundleUploadAPIClient extends CrudAPIClient {
  constructor() {
    super(GATEWAY_API_URL + '/catalog/product/stylebundleupload');
  }

  async search(query: any, page: number, size: number): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async create(payload: any): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async updateById(id: any, data: any): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async findBulk(ids: any[]): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async findById(id: any): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async createMany(payload: any[], meta: MetaQuery | undefined): Promise<any> {
    try {
      const bundles = payload.map(bundle => ({
        bundleStyle1: bundle.bundleStyle1 || null,
        bundleStyle2: bundle.bundleStyle2 || null,
        bundleStyle3: bundle.bundleStyle3 || null,
        bundleStyle4: bundle.bundleStyle4 || null,
        bundleStyle5: bundle.bundleStyle5 || null,
      }));

      const response = await axiosInstance.post(`${this.baseURL}`, { bundles });
      return this.transformList(response.data.data);
    } catch (error) {
      console.error(`Error creating style bundles in bulk:`, error);
      throw error;
    }
  }
}
